function checkValue(props: any) {
  if (props === null || props === undefined) {
    return 0;
  }
  return props;
}

export function checkString(props: any) {
  if (props === null || props === undefined) {
    return '';
  }
  return props;
}

export function convertToPercentage(total: number, someValue: number): number {
  const percentage = Number(((someValue / total) * 100).toFixed(2));
  return percentage;
}
export function convertToNumber(value: string | undefined): number {
  if (value === undefined) return 0;
  const digitsOnly = value.replace(/\D/g, '');
  const currency = parseFloat(digitsOnly) / 100;
  return currency;
}

export function convertToReal(props: number | undefined): string {
  if (props === null || props === undefined) {
    return 'N/A';
  }
  const value = props.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });

  return value;
}

export function download(fileUrl, fileName) {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.setAttribute('download', fileName);
  a.click();
}
export function convertToRealWithChecked(props: number | undefined): string {
  if (props === null || props === undefined) {
    return 'N/A';
  }
  const value = props.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });

  if (props === 0) {
    return '-';
  }
  return value;
}

export default checkValue;
